/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */

/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */
export enum EWizardAdditionalReportsSteps {
    ChooseStep = 'ChooseStep',
    PrepareStep = 'PrepareStep',
    ConfirmStep = 'ConfirmStep',
}

export enum EWizardAdditionalReports {
    REPORT_SUBSCRIBERS_WITH_LIMITS = 'REPORT_SUBSCRIBERS_WITH_LIMITS',
    REPORT_SUBSCRIBERS_WITH_MIN_LIMITS = 'REPORT_SUBSCRIBERS_WITH_MIN_LIMITS',
    REPORT_SUBSCRIBERS_WITH_PARAMETERS = 'REPORT_SUBSCRIBERS_WITH_PARAMETERS',
    REPORT_SUBSCRIBERS_WITH_BLOCK = 'REPORT_SUBSCRIBERS_WITH_BLOCK',
    REPORT_SUBSCRIBERS_NEW = 'REPORT_SUBSCRIBERS_NEW',
    REPORT_SUBSCRIBERS_WITH_STATIC_IP = 'REPORT_SUBSCRIBERS_WITH_STATIC_IP',
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/
export const WIZARD_ADDITIONAL_REPORTS_VALIDATE_START = '@@b2b_portal_ui/wizardAdditionalReports/WIZARD_ADDITIONAL_REPORTS_VALIDATE_START';
export const WIZARD_ADDITIONAL_REPORTS_VALIDATE_FINISH = '@@b2b_portal_ui/wizardAdditionalReports/WIZARD_ADDITIONAL_REPORTS_VALIDATE_FINISH';
export const WIZARD_ADDITIONAL_REPORTS_SET_PARAMS = '@@b2b_portal_ui/wizardAdditionalReports/WIZARD_ADDITIONAL_REPORTS_SET_PARAMS';
export const WIZARD_ADDITIONAL_REPORTS_HANDLE_NEXT = '@@b2b_portal_ui/wizardAdditionalReports/WIZARD_ADDITIONAL_REPORTS_HANDLE_NEXT';
